import { useState } from 'react';
import { API } from '../../services/index';

type ZipcodeResponse = Array<{
    postalCode: string;
    city: string;
    street: string;
}>;

type ZipcodeData = {
    streetname: string | null;
    city: string | null;
    zipcode: string | null;
};

export const useZipcode = () => {
    const [data, setData] = useState<ZipcodeData>({ streetname: null, city: null, zipcode: null });

    const [validZipcode, setIsValidZipcode] = useState<null | boolean>(true);

    const fetchZipcode = (zipcode: string, housenumber: string): Promise<ZipcodeData> => {
        if (!zipcode && !housenumber)
            return new Promise((res) =>
                res({
                    streetname: null,
                    city: null,
                    zipcode: null,
                }),
            );

        return new Promise<ZipcodeData>((resolve, reject) => {
            API.get<ZipcodeResponse>(`postalcode/?PostalCode=${zipcode}&HouseNumber=${housenumber}`)
                .then((res) => {
                    if (res.length > 0) {
                        const { street, city, postalCode } = res[0];

                        const data = {
                            streetname: street,
                            city: city,
                            zipcode: postalCode,
                        };
                        setData(data);
                        setIsValidZipcode(true);
                        resolve(data);
                    } else {
                        const defaultData = {
                            streetname: null,
                            city: null,
                            zipcode: null,
                        };
                        setData(defaultData);
                        setIsValidZipcode(false);
                        resolve(defaultData);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setIsValidZipcode(false);
                    reject(false);
                });
        });
    };

    return {
        data,
        validZipcode,
        fetchZipcode,
    };
};
